/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  count: 0,
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};

export const headcountNewJoinerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.HEADCOUNT_NEWJOINER + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_NEWJOINER + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        count: action.result.data.length,
        responseTime: action.result.responseTime,
        isLoading: false,
      };
    case actionType.HEADCOUNT_NEWJOINER + '_FAILED':
      return {
        ...state,
        isError: true,
        isLoading: false,
        msgError: action.err,
      };
    default:
      return state;
  }
};
